
/**
 * 创建周报信息
 */

import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';

const fields = [{
    "text": "年份",
    "field": "year",
    "disabled": true
}, {
    "text": "部门",
    "field": "orgName",
    "disabled": true,
    rules: [
        { required: true, message: '部门不能为空!' },
    ]
}, {
    "text": "第几周",
    "field": "weekNum",
    number: true,
    rules: [
        { required: true, message: '第几周不能为空!' },
    ]
}];


class ReportWeekCreateForm extends Component {

    state = {}

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let orgCode = this.props.editData.orgCode
            if (orgCode === undefined || orgCode == null) {
                messager.alert("组织信息丢失，创建失败！");
                return ;
            }
            values["orgCode"] = orgCode;
            http.post({
                url: '/reportWeek/createWeekReport',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: editData[item.field]
                        })(
                            item.number ?
                                <InputNumber precision={0} min={0} max={54} style={{ width: '100%' }} />
                                : <Input disabled={item.disabled} />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="创建周报信息"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const ReportWeekCreate = Form.create()(ReportWeekCreateForm);

export default ReportWeekCreate;